const texts = {
    "method-selector-title": {
        EN: "Select an option below",
        DA: "Vælg en mulighed nedenfor",
        DE: "Option auswählen",
        NL: "Kies een optie",
        FR: "Sélectionnez une option ci-dessous",
        IT: "Seleziona un'opzione sotto",
        ES: "Seleccione una opción a continuación",
        PT: "Selecione uma opção abaixo",
        FI: "Valitse vaihtoehto",
        SV: "Välj ett alternativ",
        NO: "Velg et alternativ",
    },
    "why-return-it": {
        EN: "Select return reason",
        DA: "Vælg returårsag",
        DE: "Rücksendegrund auswählen",
        NL: "Kies retourreden",
        FR: "Sélectionnez la raison du retour",
        IT: "Seleziona il motivo del reso",
        ES: "Seleccione el motivo de la devolución",
        PT: "Selecione o motivo da devolução",
        FI: "Valitse palautuksen syy",
        SV: "Välj returorsak",
        NO: "Velg returårsak",
    },
    "recommended-exchange-title": {
        EN: "Would you like one of these products instead?",
        DA: "Vil du hellere have et af disse produkter?",
        DE: "Möchtest du eines dieser Produkte stattdessen?",
        NL: "Wilt u in plaats daarvan een van deze producten?",
        FR: "Souhaitez-vous l'un de ces produits à la place ?",
        IT: "Vorresti uno di questi prodotti invece?",
        ES: "¿Te gustaría uno de estos productos en su lugar?",
        PT: "Gostaria de um destes produtos em vez disso?",
        FI: "Haluaisitko jonkin näistä tuotteista?",
        SV: "Vill du ha någon av dessa i stället?",
        NO: "Vil du ha en av disse i stedet?",
    },
    "complaint-type-title": {
        EN: "What happened?",
        DA: "Hvad skete der?",
        DE: "Was ist passiert?",
        NL: "Wat is er gebeurd?",
        FR: "Que s'est-il passé?",
        IT: "Cosa è successo?",
        ES: "¿Qué pasó?",
        PT: "O que aconteceu?",
        FI: "Mitä tapahtui?",
        SV: "Vad hände?",
        NO: "Hva skjedde?",
    },
    "complaint-item-broken": {
        EN: "Item is faulty",
        DA: "Varen er defekt",
        DE: "Defekter Artikel",
        NL: "Defect artikel",
        FR: "Article défectueux",
        IT: "Articolo difettoso",
        ES: "Artículo defectuoso",
        PT: "Artigo defeituoso",
        FI: "Tuote on viallinen",
        SV: "Varan är defekt",
        NO: "Defekt vare",
    },
    "complaint-wrong-item": {
        EN: "Received wrong item",
        DA: "Modtog forkert vare",
        DE: "Falscher Artikel",
        NL: "Verkeerd artikel",
        FR: "Article incorrect reçu",
        IT: "Articolo sbagliato ricevuto",
        ES: "Artículo incorrecto recibido",
        PT: "Artigo errado recebido",
        FI: "Sain väärän tuotteen",
        SV: "Fel vara",
        NO: "Feil vare",
    },
    "complaint-not-arrived": {
        EN: "Item never arrived",
        DA: "Varen ankom aldrig",
        DE: "Artikel ist nie angekommen",
        NL: "Nooit ontvangen",
        FR: "Article jamais arrivé",
        IT: "Articolo mai arrivato",
        ES: "El artículo nunca llegó",
        PT: "Artigo nunca chegou",
        FI: "Tuote ei saapunut",
        SV: "Varan kom aldrig fram",
        NO: "Kom aldri frem",
    },
    "complaint-input-step-title": {
        EN: "Tell us more",
        DA: "Fortæl os mere",
        DE: "Mehr Details",
        NL: "Vertel meer",
        FR: "Dites-nous en plus",
        IT: "Raccontaci di più",
        ES: "Cuéntanos más",
        PT: "Conte-nos mais",
        FI: "Kerro lisää",
        SV: "Berätta mer",
        NO: "Fortell mer",
    },
    "complaint-input-placeholder": {
        EN: "The problem is that...",
        DA: "Problemet er at...",
        DE: "Das Problem ist...",
        NL: "Het probleem is dat...",
        FR: "Le problème est que...",
        IT: "Il problema è che...",
        ES: "El problema es que...",
        PT: "O problema é que...",
        FI: "Ongelma on...",
        SV: "Problemet är att...",
        NO: "Problemet er at...",
    },
    "complaint-compensation-step-title": {
        EN: "If we approve your claim, would you like a new product? Select below",
        EN_TR: "If we approve your complaint, would you like a new product? Select below",
        DA: "Hvis godkendt, vil du have et nyt produkt? Vælg nedenfor",
        DE: "Wenn genehmigt, neues Produkt?",
        NL: "Als goedgekeurd, nieuw product?",
        FR: "Si approuvé, voulez-vous un nouveau produit? Sélectionnez ci-dessous",
        IT: "Se approvato, vuoi un nuovo prodotto? Seleziona sotto",
        ES: "Si se aprueba, ¿desea un nuevo producto? Seleccione a continuación",
        PT: "Se aprovado, deseja um novo produto? Selecione abaixo",
        FI: "Jos hyväksymme valituksesi, haluatko uuden tuotteen? Valitse alta",
        SV: "Om vi godkänner, vill du ha en ny?",
        NO: "Hvis godkjent, vil du ha en ny?",
    },
    "exchange-step-title": {
        EN: "What would you like instead?",
        DA: "Hvad vil du hellere have?",
        DE: "Was möchtest du stattdessen?",
        NL: "Wat wilt u in plaats daarvan?",
        FR: "Que voudriez-vous à la place?",
        IT: "Cosa vorresti invece?",
        ES: "¿Qué te gustaría en su lugar?",
        PT: "O que gostaria em vez disso?",
        FI: "Mitä haluaisit sen sijaan?",
        SV: "Vad vill du ha istället?",
        NO: "Hva vil du ha i stedet?",
    },
    "view-return-status": {
        EN: "Returned",
        DA: "Returneret",
        DE: "Zurückgegeben",
        NL: "Geretourneerd",
        FR: "Retourné(e)",
        IT: "Restituito",
        ES: "Devuelto",
        PT: "Devolvido",
        FI: "Palautettu",
        SV: "Returnerad",
        NO: "Returnert",
    },
    "method-button-title.EXCHANGE": {
        EN: "Exchange for something else",
        DA: "Byt til noget andet",
        DE: "Umtauschen",
        NL: "Ruilen",
        FR: "Échanger contre autre chose",
        IT: "Cambia con qualcos'altro",
        ES: "Cambiar por algo más",
        PT: "Trocar por outra coisa",
        FI: "Vaihda toiseen tuotteeseen",
        SV: "Byt till en annan produkt",
        NO: "Bytt til noe annet",
    },
    "method-button-title.RETURN": {
        EN: "Return item and get refund",
        DA: "Returner vare og få refusion",
        DE: "Zurückgeben & erstatten",
        NL: "Retour en terugbetaling",
        FR: "Retourner l'article et obtenir un remboursement",
        IT: "Restituisci l'articolo e ottieni un rimborso",
        ES: "Devolver artículo y obtener reembolso",
        PT: "Devolver artigo e obter reembolso",
        FI: "Palauta tuote ja saa hyvitys",
        SV: "Returnera och få pengar tillbaka",
        NO: "Returner og få refusjon",
    },
    "method-button-title.COMPLAINT": {
        EN: "Make a claim",
        EN_TR: "File a complaint",
        DA: "Reklamér",
        DE: "Reklamieren",
        NL: "Reclameren",
        FR: "Faire une réclamation",
        IT: "Fare un reclamo",
        ES: "Hacer una reclamación",
        PT: "Fazer uma reclamação",
        FI: "Tee valitus",
        SV: "Reklamera",
        NO: "Reklamer",
    },
    "method-button-subtitle.EXCHANGE.sizes": {
        EN: "Available sizes:",
        DA: "Tilgængelige størrelser:",
        DE: "Größen:",
        NL: "Maten:",
        FR: "Tailles disponibles:",
        IT: "Taglie disponibili:",
        ES: "Tallas disponibles:",
        PT: "Tamanhos disponíveis:",
        FI: "Saatavilla olevat koot:",
        SV: "Storlekar:",
        NO: "Størrelser:",
    },
    "method-button-subtitle.EXCHANGE.colors": {
        EN: "Available colors:",
        DA: "Tilgængelige farver:",
        DE: "Farben:",
        NL: "Kleuren:",
        FR: "Couleurs disponibles:",
        IT: "Colori disponibili:",
        ES: "Colores disponibles:",
        PT: "Cores disponíveis:",
        FI: "Saatavilla olevat värit:",
        SV: "Färger:",
        NO: "Farger:",
    },
    "method-button-subtitle.EXCHANGE.rest": {
        EN: "Many alternatives available",
        DA: "Mange alternativer tilgængelige",
        DE: "Viele Optionen",
        NL: "Veel opties",
        FR: "De nombreuses alternatives disponibles",
        IT: "Molte alternative disponibili",
        ES: "Muchas alternativas disponibles",
        PT: "Muitas alternativas disponíveis",
        FI: "Monta vaihtoehtoa saatavilla",
        SV: "Flera alternativ",
        NO: "Flere alternativer",
    },
    "method-button-subtitle.RETURN.paymentMethod": {
        EN: "Refund will go to the same payment method you used",
        DA: "Refusion går til samme betalingsmetode",
        DE: "Rückerstattung auf dieselbe Zahlungsmethode",
        NL: "Terugbetaling naar dezelfde betaalmethode",
        FR: "Le remboursement ira sur le même mode de paiement",
        IT: "Il rimborso andrà allo stesso metodo di pagamento",
        ES: "El reembolso se realizará al mismo método de pago",
        PT: "O reembolso será feito no mesmo método de pagamento",
        FI: "Hyvitys palautetaan samaan maksuvälineeseen",
        SV: "Återbetalning till samma betalmetod",
        NO: "Refusjon til samme betalingsmåte",
    },
    "method-button-subtitle.RETURN.orByGiftCard": {
        EN: "Refund to used payment method or by gift card ${giftCardPercentage}",
        DA: "Refusion til betalingsmetode eller gavekort ${giftCardPercentage}",
        DE: "Rückerstattung auf die verwendete Zahlungsmethode oder als Gutschein ${giftCardPercentage}",
        NL: "Terugbetaling naar gebruikte betaalmethode of als cadeaubon ${giftCardPercentage}",
        FR: "Remboursement sur le moyen de paiement utilisé ou en carte cadeau ${giftCardPercentage}",
        IT: "Rimborso sul metodo di pagamento o buono regalo ${giftCardPercentage}",
        ES: "Reembolso al método de pago o tarjeta regalo ${giftCardPercentage}",
        PT: "Reembolso no método de pagamento ou cartão presente ${giftCardPercentage}",
        FI: "Hyvitys maksuvälineeseen tai lahjakortilla ${giftCardPercentage}",
        SV: "Återbetalning till vald betalmetod eller presentkort ${giftCardPercentage}",
        NO: "Refusjon til brukt betalingsmåte eller som gavekort ${giftCardPercentage}",
    },
    "method-button-subtitle.COMPLAINT": {
        EN: "Report a problem with the item",
        DA: "Rapportér problem med varen",
        DE: "Problem melden",
        NL: "Meld probleem",
        FR: "Signaler un problème avec l'article",
        IT: "Segnala un problema con l'articolo",
        ES: "Informar un problema con el artículo",
        PT: "Relatar um problema com o artigo",
        FI: "Ilmoita ongelma tuotteesta",
        SV: "Rapportera problem",
        NO: "Rapporter problem",
    },
    "receipt-can-change": {
        EN: "Can change depending on shipping method",
        DA: "Kan ændres afhængigt af forsendelsesmetode",
        DE: "Kann je nach Versand variieren",
        NL: "Kan variëren per verzending",
        FR: "Peut changer selon le mode d'expédition",
        IT: "Può cambiare a seconda del metodo di spedizione",
        ES: "Puede cambiar según el método de envío",
        PT: "Pode mudar dependendo do método de envio",
        FI: "Voi muuttua toimitustavan mukaan",
        SV: "Kan ändras beroende på frakt",
        NO: "Kan endres avhengig av fraktmetode",
    },
    "return-items.next-back.error_text": {
        EN: "You need to select the item(s) you want to return",
        DA: "Du skal vælge de varer, du vil returnere",
        DE: "Wähle mindestens einen Artikel",
        NL: "Selecteer minimaal één artikel",
        FR: "Vous devez sélectionner le(s) article(s) à retourner",
        IT: "Devi selezionare gli articoli che vuoi restituire",
        ES: "Debe seleccionar los artículos que desea devolver",
        PT: "Você precisa selecionar o(s) artigo(s) que deseja devolver",
        FI: "Sinun täytyy valita palautettavat tuotteet",
        SV: "Välj minst en vara",
        NO: "Velg minst én vare",
    },
    "select-refund-method": {
        EN: "Select refund option",
        DA: "Vælg refusionsmulighed",
        DE: "Rückerstattungsoption wählen",
        NL: "Kies terugbetalingsoptie",
        FR: "Sélectionner l'option de remboursement",
        IT: "Seleziona opzione di rimborso",
        ES: "Seleccionar opción de reembolso",
        PT: "Selecionar opção de reembolso",
        FI: "Valitse hyvitystapa",
        SV: "Välj återbetalningsalternativ",
        NO: "Velg refusjonsalternativ",
    },
    "return-limit-passed": {
        EN: "The time limit for returning products has passed and you can no longer make returns.",
        DA: "Fristen for returnering er udløbet, og du kan ikke længere returnere.",
        DE: "Rückgabefrist abgelaufen.",
        NL: "Retourtermijn verstreken.",
        FR: "Le délai de retour des produits est dépassé et vous ne pouvez plus faire de retours.",
        IT: "Il limite di tempo per restituire i prodotti è scaduto e non puoi più fare resi.",
        ES: "El plazo para devolver productos ha pasado y ya no puedes hacer devoluciones.",
        PT: "O prazo para devolver produtos passou e você não pode mais fazer devoluções.",
        FI: "Palautusaika on päättynyt etkä voi enää palauttaa tuotteita.",
        SV: "Tiden för retur har gått ut.",
        NO: "Fristen for retur har gått ut.",
    },
    "return-limit-passed-complaint-part": {
        EN: "<br/><br/>However you can still proceed to register a complaint",
        DA: "<br/><br/>Du kan dog stadig reklamere",
        DE: "<br/><br/>Du kannst noch reklamieren",
        NL: "<br/><br/>Je kunt nog reclameren",
        FR: "<br/><br/>Cependant, vous pouvez toujours enregistrer une réclamation",
        IT: "<br/><br/>Tuttavia puoi ancora procedere a registrare un reclamo",
        ES: "<br/>\nSin embargo, aún puedes proceder a registrar una reclamación",
        PT: "\n\nNo entanto, você ainda pode prosseguir para registrar uma reclamação",
        FI: "\n\nVoit kuitenkin edelleen tehdä valituksen",
        SV: "\n\nDu kan fortfarande reklamera",
        NO: "\n\nDu kan fortsatt reklamere",
    },
};
export default texts;
